import Icon from '../primitives/Icon.jsx';
import Spinner from '../primitives/Spinner.jsx';
import { EXECUTION_STATES } from './executionStatus/executionStates.js';

/**
 * Where a piece of work stands: queued, running, waiting for you, done or failed.
 * Every state pairs a distinct shape with its color and words, so it reads without color.
 * `detail` adds a short note, such as the step or the time. `label` replaces the state's words where
 * the subject has its own (a connection that is done checking reads "Connected"); shape and color stay.
 */
const ExecutionStatus = ({ state, label, detail, size = 'md' }) => {
  const definition = EXECUTION_STATES[state];
  if (!definition) {
    throw new Error(`ExecutionStatus: unknown state "${state}"`);
  }

  return (
    <span className={`comp-execution-status comp-execution-status--${size}`} data-state={state}>
      <span className="comp-execution-status__mark">{definition.icon ? <Icon icon={definition.icon} size="sm" /> : <Spinner size={14} />}</span>
      <span className="comp-execution-status__label">{label || definition.label}</span>
      {detail && <span className="comp-execution-status__detail">{detail}</span>}
    </span>
  );
};

export default ExecutionStatus;
